import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=39a24606&scoped=true&"
import script from "./Resizer.vue?vue&type=script&lang=ts&"
export * from "./Resizer.vue?vue&type=script&lang=ts&"
import style0 from "./Resizer.vue?vue&type=style&index=0&id=39a24606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a24606",
  null
  
)

export default component.exports